import { createSelector } from 'reselect';

import { AppState } from '../../../../../../store/models/app-state';

const demandsState = (state: AppState) => state.demandDetail;

export const demandDetailTopicsDataSelector = createSelector(demandsState, state => state.topics.stepData);

/** What the step compares against to decide whether anything is unsaved. */
export const demandDetailTopicsBaselineSelector = createSelector(demandsState, state => state.topics.baseline);
